import React, { useState, useEffect } from "react";
import axios from "axios";
import { useSelector } from "react-redux";

import { getUser, getIdToken } from "../../utils/storage";
import { AllSurveys } from "./AllSurveys";
import FilteredSurveys from "./FilteredSurveys";
import { _getTotalSurveysQuestionsAndRespondents } from "../../services/api/ask/surveyQuestionsAndRespondents";
import {
  fetchCampaigns,
  fetchCampaignStatuses,
  getSurveyQuestionsAndRespondents,
  getTotalSurveyQuestions,
} from "../../services/dashboard-api";

const SurveysList = (props) => {
  const {
    client,
    setToast,
    toggleNewSurveyModalOpen,
    allSurveysList,
    setAllSurveysList,
    newAllSurveysList,
    setNewAllSurveysList,
    surveyStatus,
    setSurveyStatus,
    filter,
  } = props;

  const user = getUser(),
    idToken = getIdToken();

  const [totalQuestionsAndRespondents, setTotalQuestionsAndRespondents] =
    useState([]);

  const [versusCredits] = useState(client.versusCredits);

  const activeFilter = useSelector((state) => state.surveyFilters.activeFilter);
  const params = {
    clientRef: client.clientRef,
    uid: user.uid,
  };
  const newParams = filter.sortField
    ? { ...params, sortField: filter.sortField, sortOrder: filter.sortOrder }
    : params;
  useEffect(() => {
    //get campaign
    const getCampaigns = async () => {
      try {
        const { data } = await fetchCampaigns(newParams);
        const campaigns = data?.campaigns;
        setNewAllSurveysList(campaigns);
      } catch (error) {
        console.log("Error obtaining surveys", error.message);
        setToast({
          show: true,
          type: "warning",
          message: "We had problems retrieving surveys. Please refresh",
        });
      }
    };
    getCampaigns();

    //get campaign statuses
    const getCampaignStatuses = async () => {
      try {
        const { data } = await fetchCampaignStatuses();
        const campaignStatuses = data?.data;
        setSurveyStatus(campaignStatuses);
      } catch (error) {
        console.log("Error obtaining surveys statuses", error.message);
        setToast({
          show: true,
          type: "warning",
          message:
            "We had problems retrieving surveys statuses. Please refresh",
        });
      }
    };

    getCampaignStatuses();
  }, [client.clientRef, filter]);

  useEffect(() => {
    const getSurveyQuestionsTotal = async () => {
      try {
        const campaignsRefs = newAllSurveysList.map(
          (campaign) => campaign.campaignRef
        );

        console.log("campaignsRefs", campaignsRefs);

        const { data } = await getSurveyQuestionsAndRespondents(campaignsRefs);

        console.log("total data", data?.surveysQuestionsAndRespondentsCounts);

        setTotalQuestionsAndRespondents(
          data?.surveysQuestionsAndRespondentsCounts
        );
      } catch (error) {
        console.log(
          "Error obtaining total surveys questions and respondents.",
          error.response?.data || error.message
        );
      }
    };
    // }
    getSurveyQuestionsTotal();
  }, [allSurveysList, newAllSurveysList]);

  const statusMap = surveyStatus.reduce((acc, item) => {
    acc[item.id] = item.value;
    return acc;
  }, {});

  const filteredCampaigns = newAllSurveysList.filter(
    (campaign) =>
      statusMap[campaign.statusId]?.toLowerCase() ===
      activeFilter.filter.toLowerCase()
  );

  if (newAllSurveysList <= 0) {
    return (
      <div className="row has-cards wrap">
        <div
          className="card-2 active"
          onClick={versusCredits > 0 ? toggleNewSurveyModalOpen : null}
        >
          <div className="full-height vertical center padded padded-large">
            <h3>No surveys created</h3>
            <h2 className="main push-up">Create a new survey!</h2>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-plus icon large"
              src="https://assets.website-files.com/plugins/Image/assets/placeholder.60f9b1840c.svg"
              alt=""
            >
              <line x1="12" y1="5" x2="12" y2="19"></line>
              <line x1="5" y1="12" x2="19" y2="12"></line>
            </svg>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="row has-cards wrap">
        {activeFilter.filter === "All" ? (
          <AllSurveys
            client={client}
            setToast={setToast}
            allSurveysList={newAllSurveysList}
            newAllSurveysList={newAllSurveysList}
            surveyStatus={surveyStatus}
            totalQuestionsAndRespondents={totalQuestionsAndRespondents}
          />
        ) : activeFilter.filter === "Draft" ? (
          <FilteredSurveys
            client={client}
            setToast={setToast}
            SurveysList={filteredCampaigns}
            totalQuestionsAndRespondents={totalQuestionsAndRespondents}
            status="draft"
            surveyStatus={surveyStatus}
          />
        ) : activeFilter.filter === "Live" ? (
          <FilteredSurveys
            client={client}
            setToast={setToast}
            SurveysList={filteredCampaigns}
            totalQuestionsAndRespondents={totalQuestionsAndRespondents}
            status="live"
            surveyStatus={surveyStatus}
          />
        ) : (
          <FilteredSurveys
            client={client}
            setToast={setToast}
            SurveysList={allSurveysList}
            totalQuestionsAndRespondents={totalQuestionsAndRespondents}
            status="finished"
            surveyStatus={surveyStatus}
          />
        )}
      </div>
    );
  }
};

export default SurveysList;
